import React from 'react';
import { Card, CardContent, Typography, Grid } from '@mui/material';
import { Line } from 'react-chartjs-2';
import {
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

import { Chart as ChartJS } from 'chart.js/auto';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

export const AnalyticsCard = ({ title, icon, x, y }) => {
    const chartOptions = {
        responsive: true,
        plugins: {
            legend: {
            display: false,
            },
        },
        scales: {
            x: {
                title: {
                    display: true,
                    text: 'Day',
                },
            },
            y: {
                title: {
                    display: true,
                    text: 'Count',
                },
            },
        },
    };

    return (
        <Card sx={{ margin: '1rem', padding: '1rem' }}>
            <CardContent>
                <Grid container alignItems="center" spacing={2}>
                    <Grid item>
                        {icon}
                    </Grid>
                    <Grid item>
                        <Typography variant="h6">{title}</Typography>
                    </Grid>
                </Grid>
                <Line
                    data={{
                        labels: x,
                        datasets: [{
                            label: title,
                            data: y,
                            borderColor: 'rgba(75, 192, 192, 1)',
                            backgroundColor: 'rgba(75, 192, 192, 0.2)',
                        }],
                    }}
                    options={chartOptions}
                />
            </CardContent>
        </Card>
    )
};